// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"5b27688d","159":"8c6ef0b2","453":"3b4732f9","641":"82ea44b4","914":"baf4f12e","974":"478c6f22"}[chunkId] + ".chunk.js";
};